<app-widget [widget-meta]="this.data"
  itemCount="{{ sectionCount$ | async }}"
  showHelp="true">
  <div class="d-flex justify-content-center">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav nav-pills" [hidden]="!auth.hasFeature('TeachingCredits')">
      <li [ngbNavItem]="1" class="nav-item">
        <a ngbNavLink class="nav-link" (click)="fetchClasses('academics')">Academic</a>
        <ng-template ngbNavContent>
          @if (facultyService.classes$ | async; as academics) {
            <div>
              @if (!academics.summary) {
                <div>
                  <ng-container [ngTemplateOutlet]="classes" [ngTemplateOutletContext]="{ items:academics,tab:'academic' }"></ng-container>
                </div>
              } @else {
                <div class="widget-loading text-center">
                  <i class="fas fa-circle-notch fa-spin"></i>
                </div>
              }
            </div>
          } @else {
            <div class="widget-loading text-center">
              <i class="fas fa-circle-notch fa-spin"></i>
            </div>
          }
        </ng-template>
      </li>
      <li [ngbNavItem]="2" class="nav-item">
        <a ngbNavLink class="nav-link" (click)="fetchClasses('teachingcredits')">Teaching Credits</a>
        <ng-template ngbNavContent>
          @if (facultyService.classes$ | async; as teachingcredits) {
            <div>
              @if (teachingcredits.summary) {
                <div>
                  <ng-container [ngTemplateOutlet]="classes" [ngTemplateOutletContext]="{ items:teachingcredits, tab:'teachingcredits' }"></ng-container>
                </div>
              } @else {
                <div class="widget-loading text-center">
                  <i class="fas fa-circle-notch fa-spin"></i>
                </div>
              }
            </div>
          } @else {
            <div class="widget-loading text-center">
              <i class="fas fa-circle-notch fa-spin"></i>
            </div>
          }
        </ng-template>
      </li>
    </ul>
  </div>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
  <ng-template #classes let-items="items" let-tab="tab">
    <div class="row year-container">
      <div class="col-1"></div>
      <div class="col-md-10 col-sm-10 year-container__description ">
        @if (!(items.sectionsByGroup.length==0 && facultyService.state==-1 && !facultyService.isLoading)) {
          <button class="btn btn-sm btn-primary me-3" (click)="facultyService.pageNumber$.next( facultyService.pageNumber$.value - 1)">
            @if ((!facultyService.isLoading && facultyService.state == -1) || facultyService.state > -1) {
              <span><<</span>
            }
            @if (facultyService.isLoading && facultyService.state == -1) {
              <span class="loader loader-sm loader-light" role="status" aria-hidden="true">
                <span class="sr-only">Loading</span>
              </span>
            }
          </button>
        }
        <strong>{{items.currentYear}}</strong>
        @if (!(items.sectionsByGroup.length==0 && facultyService.state==1 && !facultyService.isLoading)) {
          <button class="btn btn-sm btn-primary ms-3" (click)="facultyService.pageNumber$.next( facultyService.pageNumber$.value + 1)">
            @if ((!facultyService.isLoading && facultyService.state == 1) || facultyService.state < 1) {
              <span>>></span>
            }
            @if (facultyService.isLoading && facultyService.state == 1) {
              <span class="loader loader-sm loader-light" role="status" aria-hidden="true">
                <span class="sr-only">Loading</span>
              </span>
            }
          </button>
          }<br />
          <a class="my-classes-current" (click)="facultyService.pageNumber$.next(0)">Current Year</a>
        </div>
      </div>
      @if (!!items.summary) {
        @if (items.summary.visible) {
          <div class="alert alert-primary mt-1">
            At the start of AY {{items.currentYear}}, you needed <strong>{{items.summary.Base}} base credits</strong>, of which <strong>{{items.summary.Release}} were released</strong>.
            @if (items.summary.Credit > 0) {
              <span>You earned <strong>{{items.summary.Credit}} async development credits</strong>.</span>
            }
            @if (items.summary.Fulltime) {
              <span>
                You had <strong>{{items.summary.Banked}} banked credits</strong>, and you may bank up to
                <strong>{{items.summary.MaxBankAccrual | number: '1.0-3'}}</strong>
                more. This year you <strong>inloaded {{items.summary.thisYearInload | number: '1.0-3'}} credits, outloaded {{items.summary.thisYearOutload | number: '1.0-3'}} credits</strong> and have
                <strong> banked {{items.summary.totalBanked | number: '1.0-3'}} credits</strong>.
              </span>
            }
            @if (items.summary.showApproval) {
              <div class="d-grid mt-1 d-flex justify-content-between">
                @if ((items.summary.IsSubmitted && !items.summary.IsApproved) && (!facultyService.tcApproved.approvedDate)) {
                  <div class="alert alert-warning d-flex align-items-center justify-content-between" role="alert">
                    <div class="px-1">
                      {{items.summary.approvalMessage}}
                    </div>
                    @if ((items.summary.IsSubmitted && !items.summary.IsApproved) && (!facultyService.tcApproved.approvedDate)) {
                      <button class="btn btn-sm btn-primary"
                        (click)="approve(items.currentYear)">
                        Approve
                        @if (facultyService.isLoading) {
                          <span class="loader loader-sm loader-light" role="status" aria-hidden="true">
                            <span class="sr-only">Loading</span>
                          </span>
                        }
                      </button>
                    }
                  </div>
                }
                @if (facultyService.approve$ | async; as approved) {
                }
                @if (items.summary.IsSubmitted && items.summary.IsApproved) {
                  <span class="badge bg-primary">
                    Approved on {{items.summary.approvedOn | date: 'mediumDate'}}
                  </span>
                }
              </div>
            }
          </div>
          <div class="row my-credits-heading">
            <div class="col-md-5 col-lg-5 col-sm-4 d-none d-sm-block">&nbsp;</div>
            <div class="col-md-2 col-lg-2 col-sm-2 d-none d-sm-block">
              Section total
            </div>
            <div class="col-md-2 col-lg-2 col-sm-2  d-none d-sm-block">
              Inloaded
            </div>
            <div class="col-md-2 col-lg-2 col-sm-2 d-none d-sm-block">
              Overloaded
            </div>
            @if (items.summary.Fulltime) {
              <div class="col-md-1 col-lg-1 col-sm-1 d-none d-sm-block">
                Bank
              </div>
            }
          </div>
        }
        @if (!items.summary.visible) {
          <div class="alert alert-primary mt-1">
            Teaching credit data have not been released by the Dean's Suite for this year.
          </div>
        }
      }
      @if (items.sectionsByGroup.length==0) {
        <div class="my-credits-heading text-center">
          @if (!!items.summary && items.summary.visible) {
            <span>No classes have been assigned to you.</span>
          }
        </div>
      }
      @for (group of items.sectionsByGroup; track group) {
        @if (items.sectionsByGroup.length > 0) {
          <div @classesLoadTrigger [ngClass]="{'academic': tab == 'academic'}">
            @if (group.Key | roleFilter) {
              <div class="mb-1 mt-1">
                <a class="my-classes-collapse" (click)="isCollapsed[group.Key] = !isCollapsed[group.Key]" [attr.aria-expanded]="!isCollapsed[group.Key]" aria-controls="collapseExample">
                  <i class="far" [ngClass]="{'fa-plus': !isCollapsed[group.Key], 'fa-minus': isCollapsed[group.Key]}"></i>&nbsp;
                  @if (!isCollapsed[group.Key]) {
                    <span>Show</span>
                  }
                  @if (isCollapsed[group.Key]) {
                    <span>Hide</span>
                  }
                  {{group.Sections.length}} {{group.Key.substring(group.Key.indexOf('^')+1)}} sections of {{group.Key.substring(group.Key.indexOf('$')+1, group.Key.indexOf('^'))}}
                </a>
              </div>
            }
            <div id="group.Key" [ngbCollapse]="collapse(group.Key)" [ngClass]="{'border p-2':isCollapsed[group.Key]}">
              @for (section of group.Sections; track section) {
                <div class="my-classes-course">
                  <div class="row">
                    <div class="col-md-5 col-lg-5 col-sm-4 my-classes-title">
                      <div class="course">
                        @if (!!section.LmsUrl) {
                          <a target="_blank" href="{{section.LmsUrl}}">{{ section.Title }}</a>
                        }
                        @if (!section.LmsUrl) {
                          <span>{{ section.Title }}</span>
                        }
                        @for (role of section.Roles; track role) {
                          <small class="badge badge-light ms-1">
                            {{role}}
                          </small>
                        }
                      </div>
                      <div>{{ section.SectionName }}: {{ section.StartsInTermName }}</div>
                      <div>{{ section.StartDate | date: 'mediumDate' }} - {{ section.EndDate | date: 'mediumDate' }}</div>
                      <div>Enrollments: {{ section.Enrolled }}  / {{ section.Seats }} ( {{ section.Reserved }} reserved )</div>
                      @if (section.CoursePackReq && section.CoursePackReq!='') {
                                    Course Pack: <a [href]="'https://coursepacks.xanedu.com/thirdparty?REQ=' + section.CoursePackReq + '&STUDENTID=' + auth.token.payload.Pid" target="_blank"><i class="fas fa-laptop"></i> Web </a>
                                    @if (section.CoursePackMobile != '') {
                          <a [href]="section.CoursePackMobile" target="_blank" class="pl-1"> <i class="fas fa-mobile-alt"></i> App</a>
                        }
                      }
                      @if ((section.StartDate | daysLeft) < 15) {
                        <div class="badge text-bg-warning">
                          Starts {{ (section.StartDate | daysLeft) == 0 ? " today!" : " in " + (section.StartDate | daysLeft) + " days!"}}
                        </div>
                      }
                    </div>
                    @if (!items.summary) {
                      <div class="col-md-3 col-lg-3 col-sm-4 my-classes-meeting">
                        @for (meeting of section.Meetings; track meeting) {
                          <div>
                            {{ meeting.Days }} {{ meeting.Start | date: 'shortTime' }} - {{ meeting.End  | date: 'shortTime' }}<br />
                            {{ meeting.Building }} {{ meeting.Room }}
                          </div>
                        }
                        @if (!!section.NonStandardMeetingInfo) {
                          <div>
                            <br />{{section.NonStandardMeetingInfo}}
                          </div>
                        }
                        @if (section.HasSyllabus) {
                          <div class="mt-1">
                            <button class="btn btn-link btn-sm pl-0" (click)="catalog.downloadSyllabus(section)">View Course Resources</button>
                            @if (section.isSyllabusDownloading) {
                              <span class="loader loader-sm" role="status" aria-hidden="true"></span>
                            }
                          </div>
                        }
                      </div>
                      <div class="col-md-4 col-lg-4 col-sm-4 mb-1 my-classes-biobooks">
                        @if (dateIsSameOrAfterToday(section.EndDate) && auth.hasFeature('SyllabusUpload')) {
                            <button
                              class="btn btn-sm btn-primary me-1 mb-1 col" title="{{section.HasSyllabus ? 'Update' : 'Add'}} Course Resources"
                            (click)="updateSyllabus(section)">{{section.HasSyllabus ? 'Update' : 'Add'}} Course Resources</button>
                          }
                            <div class="d-flex justify-content-end">
                                @if (dateIsSameOrAfterToday(section.EndDate) && !(section.Group | roleFilter)) {
                                <button [routerLink]="['/people']"
                                        [queryParams]="{sectionid: section.SectionId, tab: 'mystudents'}"
                                        class="btn btn-sm btn-primary me-1 mb-1">
                                    Students
                                </button>
                                }
                                @if (!(section.Group | roleFilter)) {
                                <app-people-download-buttons [sectionId]="section.SectionId"></app-people-download-buttons>
                                }
                            </div>
                      </div>
                    }
                    @if (items.summary) {
                      <div class="col-md-2 col-lg-2 col-sm-2 float-end">
                        <span class="d-inline-block d-sm-none me-1 fw-bold">Earned&nbsp;&ndash;</span>{{section.TeachingCreditsData.Earned | number: '1.0-3'}}
                      </div>
                      <div class="col-md-2 col-lg-2 col-sm-2 float-end">
                        <span class="d-inline-block d-sm-none me-1 fw-bold">Base&nbsp;&ndash;</span>{{section.TeachingCreditsData.Inloaded | number: '1.0-3'}}
                        @if (section.BaseMet) {
                          <i class="fas fa-flag-checkered" [ngbTooltip]="['Base Met']"></i>
                        }
                      </div>
                      <div class="col-md-2 col-lg-2 col-sm-2 float-end">
                        <span class="d-inline-block d-sm-none me-1 fw-bold">Addtl&nbsp;&ndash;</span>{{section.TeachingCreditsData.Outloaded | number: '1.0-3'}}
                      </div>
                      @if (items.summary.Fulltime) {
                        <div class="col-md-1 col-lg-1 col-sm-1 float-end">
                          <span class="d-inline-block d-sm-none me-1 fw-bold">Bank&nbsp;&ndash;</span>{{section.TeachingCreditsData.Banked | number: '1.0-3'}}
                          @if (section.BankMet) {
                            <i style="color:red" class="fas fa-lock-alt"  [ngbTooltip]="['Max Bank Reached']"></i>
                          }
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }
      @if (items.summary  && items.sectionsByGroup.length > 0) {
        @if (totals$ | async; as totals) {
          <div class="row my-credits-heading">
            <div class="col-md-5 col-lg-5 col-sm-4"><span class="d-inline-block d-sm-none me-1 fw-bolder">Total</span></div>
            <div class="col-md-2 col-lg-2 col-sm-2">
              <span class="d-inline-block d-sm-none me-1 fw-bold">Earned&nbsp;&ndash;</span>{{totals.earned | number: '1.0-3'}}
            </div>
            <div class="col-md-2 col-lg-2 col-sm-2">
              <span class="d-inline-block d-sm-none me-1 fw-bold">Base&nbsp;&ndash;</span>{{totals.base | number: '1.0-3'}}
            </div>
            <div class="col-md-2 col-lg-2 col-sm-2">
              <span class="d-inline-block d-sm-none me-1 fw-bold">Addtl&nbsp;&ndash;</span>{{totals.addtl | number: '1.0-3'}}
            </div>
            @if (items.summary.Fulltime) {
              <div class="col-md-1 col-lg-1 col-sm-1">
                <span class="d-inline-block d-sm-none me-1 fw-bold">Bank&nbsp;&ndash;</span>{{totals.bank | number: '1.0-3'}}
              </div>
            }
          </div>
        }
      }
      <div class="row year-container">
        <div class="col-1"></div>
        <div class="col-md-10 col-sm-10 year-container__description ">
          <a class="my-classes-current" (click)="facultyService.pageNumber$.next(0)">Current Year</a><br />
          @if (!(items.sectionsByGroup.length==0 && facultyService.state== -1 && !facultyService.isLoading)) {
            <button class="btn btn-sm btn-primary me-3" (click)="facultyService.pageNumber$.next( facultyService.pageNumber$.value - 1)">
              @if ((!facultyService.isLoading && facultyService.state == -1) || facultyService.state > -1) {
                <span><<</span>
              }
              @if (facultyService.isLoading && facultyService.state == -1) {
                <span class="loader loader-sm loader-light" role="status" aria-hidden="true">
                  <span class="sr-only">Loading</span>
                </span>
              }
            </button>
          }
          <strong>{{items.currentYear}}</strong>
          @if (!(items.sectionsByGroup.length==0 && facultyService.state==1 && !facultyService.isLoading)) {
            <button class="btn btn-sm btn-primary ms-3" (click)="facultyService.pageNumber$.next( facultyService.pageNumber$.value + 1)">
              @if ((!facultyService.isLoading && facultyService.state == 1) || facultyService.state < 1) {
                <span>>></span>
              }
              @if (facultyService.isLoading && facultyService.state == 1) {
                <span class="loader loader-sm loader-light" role="status" aria-hidden="true">
                  <span class="sr-only">Loading</span>
                </span>
              }
            </button>
          }
        </div>
      </div>
      @if (csv$ | async) {
        <div></div>
      }
    </ng-template>


  </app-widget>
